import type { SlateBlock, TableBlock } from '@atlas/renderer';
import { Editor, Transforms, Node, Path } from 'slate';
import { ReactEditor } from 'slate-react';

export default function insertTable(editor: Editor) {
    ReactEditor.focus(editor);
    const { selection } = editor;
    const node: TableBlock = {
        type: 'table',
        children: [
            {
                type: 'table-row',
                children: [
                    { type: 'table-cell', children: [{ text: '' }] },
                    { type: 'table-cell', children: [{ text: '' }] },
                ],
            },
            {
                type: 'table-row',
                children: [
                    { type: 'table-cell', children: [{ text: '' }] },
                    { type: 'table-cell', children: [{ text: '' }] },
                ],
            },
        ],
    };

    if (!selection) {
        // Insert the new table node at the bottom of the Editor when selection is falsy
        Transforms.insertNodes(editor, node, { select: true });
        return;
    }

    const [parentNode, parentPath] = Editor.parent(editor, selection.focus?.path);

    if (editor.isVoid(parentNode as SlateBlock) || Node.string(parentNode).length) {
        // Insert the new table node after the void node or a node with content
        Transforms.insertNodes(editor, node, {
            at: Path.next(parentPath),
            select: true,
        });
    } else {
        // If the node is empty, replace it instead
        Transforms.removeNodes(editor, { at: parentPath });
        Transforms.insertNodes(editor, node, {
            at: parentPath,
            select: true,
        });
    }
    Transforms.unwrapNodes(editor, {
        mode: 'all',
        at: parentPath,
        split: true,
        match: (node) => 'type' in node && !node.type.startsWith('table'),
    });
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('insertTable', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
